import React, { useContext, useEffect, useState } from "react";
import Header from "./Comman/Header";
import { OnmaxContext } from "../OnmaxContext";
import axios from "axios";


export default function Stake() {
  const { toastSuccess, toastError, settings, } = useContext(OnmaxContext);
  const [StakeStatus, setStakeStatus] = useState(false);
  const [StakeReason, setStakeReason] = useState('');
  const username = localStorage.getItem("username");

  const [packages, setPackages] = useState([]);

  // CHANGED: Using Index to track selection to ensure we always get the object correctly
  const [selectedPackageIndex, setSelectedPackageIndex] = useState("");

  const [quantity, setQuantity] = useState(1);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [profile, setprofile] = useState(null);


  const getprofileData = async () => {
    if (!username) return;

    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "profile",
        username,
        key: process.env.REACT_APP_KEY,
      });

      if (res.data?.error || !res.data?.data) {
        setprofile(null);
      } else {
        setprofile(res.data.data);
      }
    } catch (error) {
      console.error("Profile fetch error:", error);
      setprofile(null);
    }
  };

  useEffect(() => {
    getprofileData()
  }, [username]);


  // Fetch packages from backend
  const getPackages = async () => {
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "package",
        submethod: "get",
        key: process.env.REACT_APP_KEY,
      });

      if (!res.data.error && Array.isArray(res.data.data)) {
        setPackages(res.data.data);
      } else {
        setPackages([]);
      }
    } catch (err) {
      toastError("Failed to fetch packages");
    }
  };

  useEffect(() => {
    getPackages();
  }, []);

  const handlePackageChange = (e) => {
    const idx = e.target.value;
    setSelectedPackageIndex(idx);
    setQuantity(1);
  };


  useEffect(() => {
    if (selectedPackageIndex !== "" && packages[selectedPackageIndex]) {
      const pkg = packages[selectedPackageIndex];

      const price = Number(pkg.amount) || 0;
      const qty = Number(quantity);

      if (!isNaN(qty) && qty > 0) {
        setTotalAmount(price * qty);
      } else {
        setTotalAmount(0);
      }
    } else {
      setTotalAmount(0);
    }
  }, [selectedPackageIndex, quantity, packages]);


  useEffect(() => {
    if (Array.isArray(settings) && settings.length > 0) {
      const StakeStatus = settings[0].stake_status;
      const reason = settings[0].stake_msg;
      setStakeStatus(StakeStatus === true);
      setStakeReason(reason || '');
    }
  }, [settings]);


  const handleBuy = async () => {
    if (selectedPackageIndex === "" || !packages[selectedPackageIndex]) {
      return toastError("Select a package first");
    }

    // Get directly from array using index
    const pkg = packages[selectedPackageIndex];
    if (!pkg) return toastError("Invalid Package Selection");

    // if (!quantity || quantity <= 0) return toastError("Enter a valid quantity");

    setLoading(true);
    try {
      const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
        method: "transaction",
        submethod: "insert",
        // username: username,
        value: 1,
        amount: pkg.amount,
        packageId: pkg.id, // We still send the ID to backend
        key: process.env.REACT_APP_KEY,
      },{ withCredentials: true }
      );
      console.log('res stake', res);

      if (res.data?.resCode === 401) {
        toastError("Login Expired!");

        // Call logout immediately
        try {
          const logout = await axios.post(
            process.env.REACT_APP_BACKEND_LINK,
            {
              method: "user",
              submethod: "logoutu",
              username: username,
              key: process.env.REACT_APP_KEY,
            }
          );
          // console.log('res logout', logout);
          // Cookie.remove("token")
          localStorage.clear();
          // navigate("/");
          window.location.replace("/");
        } catch (error) {
          console.error("Logout failed:", error);
        }
      }
      if (res.data?.resCode === 200) {
        toastSuccess(res.data.msg || "Purchase successful!");
        getprofileData();
        setQuantity(1);
        setSelectedPackageIndex("");
      }
      if (res.data?.resCode === 400) {
        toastError(res.data.error || "Purchase failed!");
      }
    } catch (err) {
      console.error(err);
      toastError("Network or server error!");
    }
    setLoading(false);
  };

  const handleQtyChange = (val) => {
    if (val === "") {
      setQuantity("");
      return;
    }
    const v = parseInt(val);
    if (!isNaN(v) && v >= 0) {
      setQuantity(v);
    }
  };

  const handleQtyBlur = () => {
    if (quantity === "" || quantity < 1) setQuantity(1);
  };

  const customStyles = `
    .db-input-group { margin-bottom: 24px; position: relative; }
    .db-input-label { font-size: 11px; text-transform: uppercase; letter-spacing: 1.5px; color: #64748b; font-weight: 800; margin-bottom: 8px; display: block; }
    .db-input-box { 
      background: rgba(238, 242, 246, 0.5); 
      border-radius: 16px; 
      padding: 12px 20px; 
      border: 1px solid rgba(255, 255, 255, 0.8);
      box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
      display: flex; align-items: center; gap: 12px;
      position: relative;
      transition: all 0.3s;
    }
    .db-input-box:focus-within {
       border-color: #006fe3;
    }
    .db-input-field { background: transparent; border: none; outline: none; width: 100%; font-weight: 700; color: #1e293b; font-size: 16px; }
    .db-input-field::placeholder { color: #94a3b8; font-weight: 500; }
    .db-input-icon { color: #006fe3; font-size: 18px; }

    .ai-loading-overlay {
      position: absolute;
      inset: 0;
      background: rgba(255, 255, 255, 0.85);
      backdrop-filter: blur(4px);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      z-index: 20;
    }
    .ai-loading-overlay .progress { width: 80%; }

    .ai-qty-group {
       display: flex; align-items: center; justify-content: center;
       background: rgba(238, 242, 246, 0.5); border-radius: 16px;
       padding: 8px; border: 1px solid rgba(255, 255, 255, 0.8);
       height: 56px;
       box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
    }
    .ai-qty-btn {
       width: 36px; height: 36px;
       background: #1e293b; border: 1px solid #334155;
       border-radius: 8px; color: #fff; font-size: 18px;
       cursor: pointer; transition: 0.2s;
       display: flex; align-items: center; justify-content: center;
    }
    .ai-qty-btn:hover { border-color: #f59e0b; color: #f59e0b; }
    
    .ai-qty-input {
       flex: 1; text-align: center;
       font-size: 20px; font-weight: 700; color: #1e293b;
       background: transparent; border: none; outline: none;
       width: 50px;
    }
    .ai-qty-input::-webkit-outer-spin-button, .ai-qty-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }

    .ai-total-display {
       display: flex; align-items: center; justify-content: center;
       background: rgba(16, 185, 129, 0.1); border: 1px solid rgba(16, 185, 129, 0.2);
       border-radius: 16px; height: 56px;
       font-size: 20px; font-weight: 700; color: #059669;
    }
  `;

  return (
    <>
      <style>{customStyles}</style>
      <div className="body-bg">
        <Header />
        <section className="nftmax-adashboard nftmax-show mt-4 setting-section">
          <div className="container">
            <div className="row justify-content-center">

              <div className="col-lg-6 col-md-8 col-12">

                {StakeStatus === false ? (
                  <div className="db-profile-card mb-4 text-center" style={{ border: '2px solid #ef4444' }}>
                    <div className="text-danger fw-bold"><i className="fa fa-ban me-2"></i> {StakeReason || "Staking Disabled"}</div>
                  </div>
                ) : (
                  <div className="db-profile-card mb-5" style={{ position: 'relative' }}>

                    <div className="db-sec-hdr">
                      <div className="db-sec-dot"></div>
                      <div className="db-sec-title">Buy Package</div>
                    </div>

                    <div className="p-0">

                      <div className="text-center mb-4 mt-3">
                        <span style={{ background: 'rgba(245, 158, 11, 0.1)', color: '#d97706', padding: '8px 20px', borderRadius: '100px', fontSize: '14px', border: '1px solid rgba(245, 158, 11, 0.2)', fontWeight: '800', boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                          Wallet Balance: ${profile?.totaldeposit ? Number(profile.totaldeposit).toFixed(2) : "0.00"}
                        </span>
                      </div>

                      <div className="db-input-group">
                        <label className="db-input-label">Select Package</label>
                        <div className="db-input-box">
                          <div className="db-input-icon-box icon-cyan">
                            <i className="fa fa-layer-group db-input-icon"></i>
                          </div>
                          <select
                            className="db-input-field"
                            value={selectedPackageIndex}
                            disabled={loading}
                            onChange={handlePackageChange}
                            style={{ appearance: 'none', cursor: 'pointer' }}
                          >
                            <option value="">-- Choose Package --</option>
                            {packages.map((pkg, index) => (
                              <option key={index} value={index}>
                                {pkg.p_name} - ${pkg.amount}
                              </option>
                            ))}
                          </select>
                          <i className="fa fa-chevron-down" style={{ position: 'absolute', right: '20px', color: '#64748b', pointerEvents: 'none' }}></i>
                        </div>
                      </div>

                      <div className="row g-3 mb-4">
                        <div className="col-6">
                          <label className="db-input-label">Quantity</label>
                          <div className="ai-qty-group">
                           {/*} <button className="ai-qty-btn" onClick={() => {
                              let current = parseInt(quantity);
                              if (isNaN(current)) current = 0;
                              setQuantity(Math.max(1, current - 1));
                            }}>-</button>*/}
                            <input
                              type="number"
                              disabled
                              className="ai-qty-input border-0"
                              value={quantity}
                              disabled={loading}
                              onChange={(e) => handleQtyChange(Number(1))}
                              onBlur={handleQtyBlur}
                            />
                            {/*<button className="ai-qty-btn" onClick={() => {
                              let current = parseInt(quantity);
                              if (isNaN(current)) current = 0;
                              setQuantity(current + 1);
                            }}>+</button>*/}
                          </div>
                        </div>
                        <div className="col-6">
                          <label className="db-input-label">Payable</label>
                          <div className="ai-total-display">
                            ${totalAmount.toFixed(2)}
                          </div>
                        </div>
                      </div>

                      {/* 🔄 SHOW PROGRESS BAR (AI SCANNER) */}
                      {loading && (
                        <div className="ai-loading-overlay">
                          <div className="text-center">
                            <h4 className="fw-bold text-dark mb-1">Buy Package</h4>
                            <p className="text-secondary small mb-3">Confirming Purchase</p>

                            <div className="spinner-border text-primary mb-3" role="status"></div>
                            <p className="text-warning fw-bold mb-3">
                              ⚠ Please do NOT refresh or close this page
                            </p>
                            <div className="progress mx-auto" style={{ height: 8 }}>
                              <div className="progress-bar progress-bar-striped progress-bar-animated bg-primary" style={{ width: "100%" }}></div>
                            </div>
                          </div>
                        </div>
                      )}

                      <button
                        className="db-btn w-100 py-3 mt-2"
                        onClick={handleBuy}
                        disabled={loading}
                        style={{ background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: 'white', border: 'none', borderRadius: '16px', fontWeight: '800', boxShadow: '0 10px 20px rgba(245, 158, 11, 0.3)' }}
                      >
                        {loading ? "PROCESSING..." : "CONFIRM PURCHASE"}
                      </button>

                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
